

<template>
  <MasonryWall v-if="items.length > 0"  :min-columns="minColumns" :column-width="columnWidth" :max-columns="maxColumns" :items="items" :ssr-columns="2" :gap="16">
    <template #default="{ item, index }">
        <slot :item="item" :index="index"></slot>
    </template>
  </MasonryWall>
</template>

<script>
import MasonryWall from '@yeger/vue-masonry-wall'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    MasonryWall,
  },

  props:{
    items:{
        type:Array,
        required:true
    },
    maxColumns:{
      type:Number,
      default:3
    },
    minColumns:{
      type:Number,
      default:3
    },
    columnWidth:{
      type:Number,
      default:300
    }
  },

  data() {
    return {
    }
  },
})
</script>